export const orders = {
    en: {
        title: 'Orders',
        export: 'Export',
        order_updated: 'Order updated successfully',
        update_error: 'Error updating order',
        delete_error: 'Error deleting order',
        confirm_delete: 'Are you sure you want to delete this order?',
        order_deleted: 'Order deleted successfully',
        order_returned: 'Order returned successfully',
        return_error: 'Error returning order',
        failed_to_load_orders: 'Failed to load orders',
        uploading: 'Uploading…',
        bulk_upload: 'Bulk Upload ZATCA',
        bulk_upload_done: 'Bulk upload completed',
        bulk_upload_failed: 'Bulk upload failed',
        zatca_gateway_down: 'ZATCA service is currently unreachable. Please try again later.',
        zatca_upload_success: 'Uploaded to ZATCA',
        zatca_upload_failed: 'Failed to upload to ZATCA',
        zatca_delete_blocked: 'This order was reported to ZATCA and cannot be deleted. Use return instead.',
        details: {
            title: 'Order Details',
            type: 'Order Type',
            pickup: 'Pickup',
            delivery: 'Delivery',
            table: 'Table Service',
            searchCustomer: 'Search Customer',
            searchPlaceholder: 'Search by name or phone',
            newCustomer: 'New Customer',
            tableNumber: 'Table Number',
            submit: 'Submit',
            cancel: 'Cancel',
            loadingCustomers: 'Loading customers...',
            noCustomersFound: 'No customers found'
        },
        errors: {
            loadingCustomers: 'Error loading customers',
            selectCustomer: 'Please select a customer',
            enterTableNumber: 'Please enter table number'
        },
        filters: {
            start_date: 'Start Date & Time',
            end_date: 'End Date & Time',
            payment_method: 'Payment Method',
            order_type: 'Order Type',
            all_methods: 'All Methods',
            cash: 'Cash',
            card: 'Card',
            status: 'Status',
            all: 'All',
            returned: 'Returned',
            order_number: 'Order Number',
            search_by_order_number: 'Search by order number',
            clear_filters: 'Clear Filters',
            search_orders: 'Search Orders'
        }
    },
    ar: {
        title: 'الطلبات',
        export: 'تصدير',
        order_updated: 'تم تحديث الطلب بنجاح',
        update_error: 'خطأ في تحديث الطلب',
        delete_error: 'خطأ في حذف الطلب',
        confirm_delete: 'هل أنت متأكد من حذف هذا الطلب؟',
        order_deleted: 'تم حذف الطلب بنجاح',
        order_returned: 'تم إرجاع الطلب بنجاح',
        return_error: 'خطأ في إرجاع الطلب',
        failed_to_load_orders: 'فشل في تحميل الطلبات',
        uploading: 'جاري الرفع…',
        bulk_upload: 'رفع جماعي إلى زاتكا',
        bulk_upload_done: 'تم إكمال الرفع',
        bulk_upload_failed: 'فشل الرفع الجماعي',
        zatca_gateway_down: 'خدمة زاتكا غير متاحة حالياً. يرجى المحاولة لاحقاً.',
        zatca_upload_success: 'تم الرفع إلى زاتكا',
        zatca_upload_failed: 'فشل الرفع إلى زاتكا',
        zatca_delete_blocked: 'تم رفع هذا الطلب إلى زاتكا ولا يمكن حذفه. استخدم الإرجاع بدلاً من ذلك.',
        details: {
            title: 'تفاصيل الطلب',
            type: 'نوع الطلب',
            pickup: 'استلام',
            delivery: 'توصيل',
            table: 'خدمة الطاولة',
            searchCustomer: 'بحث عن عميل',
            searchPlaceholder: 'البحث بالاسم أو رقم الهاتف',
            newCustomer: 'عميل جديد',
            tableNumber: 'رقم الطاولة',
            submit: 'تأكيد',
            cancel: 'إلغاء',
            loadingCustomers: 'جاري تحميل العملاء...',
            noCustomersFound: 'لم يتم العثور على عملاء'
        },
        errors: {
            loadingCustomers: 'خطأ في تحميل العملاء',
            selectCustomer: 'الرجاء اختيار عميل',
            enterTableNumber: 'الرجاء إدخال رقم الطاولة'
        },
        filters: {
            start_date: 'تاريخ ووقت البداية',
            end_date: 'تاريخ ووقت النهاية',
            payment_method: 'طريقة الدفع',
            order_type: 'نوع الطلب',
            all_methods: 'جميع الطرق',
            cash: 'نقدي',
            card: 'بطاقة',
            status: 'الحالة',
            all: 'الكل',
            returned: 'مرتجع',
            order_number: 'رقم الطلب',
            search_by_order_number: 'البحث برقم الطلب',
            clear_filters: 'مسح الفلاتر',
            search_orders: 'بحث الطلبات'
        }
    }
};
